import { UPPERCASE_WORDS } from './textCaseRules.js';

export const formatTextCase = (text = '') => {
  return UPPERCASE_WORDS?.includes(text?.toLowerCase?.())
    ? text?.toUpperCase?.()
    : text
};